import React, { useMemo, useState } from "react";
import { alpha } from "@mui/material/styles";
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Box, Button, Stack } from "@mui/material";

import { chartTabs, monthlyData } from "../constants";

function MonthlyTrendChart({ theme }) {
  const [chartTab, setChartTab] = useState("Volumi (€)");

  const conversionData = useMemo(
    () =>
      monthlyData.map((entry) => ({
        month: entry.month,
        conversion: entry.preventivi > 0 ? Number(((entry.polizze / entry.preventivi) * 100).toFixed(1)) : 0,
      })),
    []
  );

  return (
    <>
      <Stack direction="row" spacing={1} sx={{ p: 0.5, bgcolor: alpha(theme.palette.primary.main, 0.06), borderRadius: 3 }}>
        {chartTabs.map((tab) => (
          <Button key={tab} variant={chartTab === tab ? "contained" : "text"} onClick={() => setChartTab(tab)} size="small" sx={{ borderRadius: 2, textTransform: "none", minWidth: 105 }}>
            {tab}
          </Button>
        ))}
      </Stack>

      <Box sx={{ height: 320 }}>
        <ResponsiveContainer width="100%" height="100%">
          {chartTab === "Volumi (€)" ? (
            <BarChart data={monthlyData}>
              <CartesianGrid strokeDasharray="3 3" stroke={alpha(theme.palette.text.primary, 0.1)} />
              <XAxis dataKey="month" />
              <YAxis
                domain={[0, 2500]}
                ticks={[0, 1000, 1500, 2000, 2500]}
                tickFormatter={(value) => `€${Math.round(value / 1000)}K`}
              />
              <Tooltip formatter={(value) => `€ ${Number(value).toLocaleString("it-IT")}`} />
              <Bar dataKey="premi" name="Volumi (€)" fill="#3B82F6" radius={[10, 10, 0, 0]} />
            </BarChart>
          ) : chartTab === "Pratiche" ? (
            <BarChart data={monthlyData}>
              <CartesianGrid strokeDasharray="3 3" stroke={alpha(theme.palette.text.primary, 0.1)} />
              <XAxis dataKey="month" />
              <YAxis domain={[0, 12]} ticks={[0, 3, 6, 9, 12]} />
              <Tooltip />
              <Legend verticalAlign="bottom" align="center" iconType="circle" />
              <Bar dataKey="preventivi" name="Preventivi" fill="#3B82F6" radius={[6, 6, 0, 0]} />
              <Bar dataKey="polizze" name="Polizze" fill="#22C55E" radius={[6, 6, 0, 0]} />
            </BarChart>
          ) : (
            <LineChart data={conversionData}>
              <CartesianGrid strokeDasharray="3 3" stroke={alpha(theme.palette.text.primary, 0.1)} />
              <XAxis dataKey="month" />
              <YAxis domain={[0, 60]} ticks={[0, 15, 30, 45, 60]} tickFormatter={(value) => `${value}%`} />
              <Tooltip formatter={(value) => `${value}%`} />
              <Line
                type="monotone"
                dataKey="conversion"
                name="Conversione %"
                stroke="#22C55E"
                strokeWidth={4}
                dot={{ r: 5, fill: "#22C55E" }}
                activeDot={{ r: 7 }}
              />
            </LineChart>
          )}
        </ResponsiveContainer>
      </Box>
    </>
  );
}

export default MonthlyTrendChart;
